import { put, call } from "redux-saga/effects";
// import get_api from "../../../../../lib/LockerSettings/GetApi";
import get_api from "../api/GetApi";
import { changePayMethodViewAction } from "../actions/index";
import { globalStartLoading, globalFinishLoading } from "modules/actions/Loading/index";

export function* getChangePayMethodViewInfoData(param) {
  try {
    yield put(globalStartLoading());
    const { data } = yield call(get_api.getViewInfo, param);

    if (data.data === null) {
      yield put(changePayMethodViewAction.loadChangePayMethodViewSuccess(false));
    } else {
      yield put(changePayMethodViewAction.loadChangePayMethodViewSuccess(data));
    }
    yield put(globalFinishLoading());
  } catch (error) {
    console.log("from saga  -> ");
    console.log(error);
    yield put(changePayMethodViewAction.loadChangePayMethodViewFail(error));
    yield put(globalFinishLoading());
  }
}
